module.exports = __webpack_public_path__ + "static/img/rrrr_42.74b9c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_42.png
// module id = GMej
// module chunks = 1